import { ControlInterface } from 'edocatbase/Form';
import Field from '../../../../../advanced-comments/components/List/Field';

const validTypes = ['text', 'number', 'password'];
const Input = window.Edocat.Components.TextField;

interface TextFieldInterface extends ControlInterface {
	multiline: boolean;
	readOnly?: boolean;
	url: string;
	onChange: (name: string[], value: any, dirty: boolean, stopPropagate?: boolean) => void;
	onIn?: (name: string, data?: any) => void;
	important?: string;
}

export default class TextField extends window.React.PureComponent<TextFieldInterface> {
	onFieldChange = (event: React.ChangeEvent) => {
		event.preventDefault();
		const { onChange, name, dirty } = this.props;
		const { value } = event.target as HTMLInputElement;
		onChange([name], value, dirty);
	};

	onFieldInput = (event: React.ChangeEvent) => {
		event.preventDefault();
		const { onIn, name } = this.props;
		const { value } = event.target as HTMLInputElement;
		onIn && onIn(name, { value: value });
	};

	onBlur = () => {
		const { onBlur, name, value, dirty } = this.props;
		// @ts-ignore
		onBlur(name, value, dirty);
	};

	render() {
		const {
			autoFocus,
			dataType,
			disabled,
			value,
			label,
			error,
			control: {
				params: { forceEditable, endAdornment },
			},
			name,
			className,
			mandatory,
			multiline,
			placeholder,
			readOnly,
			url,
			important,
		} = this.props;

		const type = dataType === 'int' || dataType === 'long' || dataType === 'double' ? 'number' : null;

		const finalValue = readOnly && dataType === 'double' ? String(value).replace('.', ',') : value;

		return readOnly && name.includes('mmAspect') && value ? (
			<div className={`form-row row-${name} simple-row`}>
				<label>{label}</label>
				<div id={name}>
					<a href={url} target="_blank" className="search-link">
						{finalValue || window.Alfresco.messages.global['label.none']}
					</a>
				</div>
			</div>
		) : readOnly || disabled ? (
			<div className={`form-row row-${name} ${readOnly ? 'simple-row' : 'read-only-row'}`}>
				<label>{label}</label>
				<div id={name}>{finalValue || window.Alfresco.messages.global['label.none']}</div>
			</div>
		) : (
			<div className={`form-row row-${name}`}>
				<Input
					autoComplete={dataType === 'password' ? 'new-password' : null}
					autoFocus={autoFocus}
					className={className}
					disabled={forceEditable || readOnly ? false : disabled}
					error={error}
					id={name}
					label={label}
					mandatory={mandatory}
					multiline={multiline}
					name={name}
					onBlur={this.onBlur}
					onChange={this.onFieldChange}
					onInput={this.onFieldInput}
					rows={readOnly ? (multiline && finalValue ? 5 : 1) : 5}
					type={type || (validTypes.includes(dataType) ? dataType : 'text')}
					value={readOnly ? finalValue || window.Alfresco.messages.global['label.none'] : value ?? ''}
					placeholder={readOnly ? null : placeholder}
					endAdornment={endAdornment}
					readOnly={readOnly}
					important={important}
				/>
			</div>
		);
	}
}
